export enum CookieKeyEnum {
  JWT_TOKEN = 'jwt',
  REFRESH_TOKEN = 'refresh',

  // JWT_TOKEN_BUSINESS and REFRESH_TOKEN_BUSINESS is used on both landing and business, so this key needs to be separate
  JWT_TOKEN_BUSINESS = 'jwtBusiness',
  REFRESH_TOKEN_BUSINESS = 'refreshBusiness',
}

export enum MobiferProjectEnum {
  OPERATOR = 'operator',
  BUSINESS = 'corporate',
  SUPERADMIN = 'superadmin',
}

export enum PricingAdjustmentTypeEnum {
  DISCOUNT = 'DISCOUNT',
  MARKUP = 'MARKUP',
}

export enum TravelModeEnum {
  NORMAL = 'NORMAL',
  FERRY = 'FERRY',
  CITY_HIRE = 'CITY_HIRE',
}

export enum CreateRideOfferEnum {
  CREATE_ORDER = 'CREATE_ORDER',
  SEND_OFFER = 'SEND_OFFER',
}

export enum TokenStatus {
  OK = 'OK',
  EXPIRED = 'EXPIRED',
  NOT_FOUND = 'NOT_FOUND',
}
